const images = {
    logo: require('./logo.svg').default,
    defaultImage: require('./defaultImage.jpg'),
    footer: require('./footer.jpg'),
};

export default images;
